/**
 * @file
 */


export function InitializeDefaultPage() {
   var owl = $('.owl-carousel');
   owl.owlCarousel({
      items: 1,
      loop: true,
      margin: 0,
      nav: true,
      dots: true,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: false,
      animateOut: 'fadeOut',   
   });


   $('.homepage-Carousel-Options-Play').attr("aria-pressed", "true");
   $('.homepage-Carousel-Options-Pause').attr("aria-pressed", "false");


  $('.homepage-Carousel-Options-Play').on('click', function () {
    if ($(this).attr("aria-pressed") == "false") {
      owl.trigger('play.owl.autoplay', [5000]);
      $(this).attr("aria-pressed", "true");
      $('.homepage-Carousel-Options-Pause').attr("aria-pressed", "false");
    } 
   });

  $('.homepage-Carousel-Options-Pause').on('click', function () {
    if ($(this).attr("aria-pressed") == "false") {
      owl.trigger('stop.owl.autoplay');
      $(this).attr("aria-pressed", "true");
      $('.homepage-Carousel-Options-Play').attr("aria-pressed", "false");
    }
  });

   $('.homepage-Carousel-Options-Play').on( "keydown", function (event) {
      if (event.which == 32) {
         owl.trigger('play.owl.autoplay', [5000]);
      }
   });

   $('.homepage-Carousel-Options-Pause').on("keydown", function (event) {
      if (event.which == 32) {
         owl.trigger('stop.owl.autoplay', [5000]);
      }
   });

    var indexValue = 1;
    $('.owl-dots button').each(function (index) {
        var labelText = "slide " + indexValue;
        $(this).attr("aria-label", labelText);
        $(this).attr("title", labelText);
        indexValue = indexValue + 1;
    });

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.AnnouncementClose = AnnouncementClose;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.NotificationsLink = NotificationsLink;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.CorrespondenceLink = CorrespondenceLink;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.toggleLoginBox = toggleLoginBox;
};

function AnnouncementClose() {
  $('#divAnnouncements').dialog('close');
  $('.searchLink').removeClass('hide');
  return false;
}

function NotificationsLink() {
   $.ajax({
      type: "POST",
      url: "Default.aspx/NotificationsLink",
      data: '',
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      async: false
   });
   return true;
}

function CorrespondenceLink() {
   $.ajax({
      type: "POST",
      url: "Default.aspx/CorrespondenceLink",
      data: '',
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      async: false
   });
   return true;
}

function toggleLoginBox() {
   var accessButton = $(".accountAccessButton");
   var accessButtonX = $("#aaccountAccessButtonX");
   
    // has primary class: display the login box (remove the hide class)
   if (accessButton.hasClass("primary")) {
      accessButton.removeClass("primary");
      accessButton.addClass("secondary");
      accessButtonX.show();
      accessButton.hide()
        $('.homepage-bannerLogin-loginBox').removeClass("loginBoxHide");
        $('.homepage-bannerLogin-loginBox').addClass("loginBoxShow");
    }
    // hide the login box and display login access button
   else {
      accessButtonX.hide();
      accessButton.show()
      accessButton.removeClass("secondary");
      accessButton.addClass("primary");
        $('.homepage-bannerLogin-loginBox').removeClass("loginBoxShow");
        $('.homepage-bannerLogin-loginBox').addClass("loginBoxHide");
    }

}
